const config = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || "http://localhost:5196",
  buildMode: process.env.REACT_APP_BUILD_MODE || "sandbox",
};

export default config;
